import { styled } from 'styled-components'
import { motion } from 'motion/react'

export const StyledCodeBlock = styled(motion.pre)`
  position: relative;
  background-color: ${({ theme }) => theme.colors.codeblock.background};
  padding: 1rem;
  border-radius: 8px;
  overflow-x: auto;
  font-family: 'Fira Code', monospace;

  code {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.codeblock.color};
  }
`

export const StyledClickMessage = styled(motion.p)`
  font-style: italic;
`

export const StyledRunButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: ${({ theme }) => theme.colors.codeblock.copyButton.background};
  color: ${({ theme }) => theme.colors.codeblock.copyButton.color};
  border: none;
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.codeblock.copyButton.hoverBackground};
  }
`
